import {Icon, Text} from '#component/base';
import {DeltaTrendChart} from '#component/partial';
import {sprinkles} from '#style/sprinkles';

import {DeltaTabProps} from './DeltaTab.types';

const legendItems = [
  {
    icon: (
      <Text color="doveGray" fontWeight="semiBold" variant="caption">
        –
      </Text>
    ),
    label: 'Chron. age',
  },
  {
    icon: <Icon color="doveGray" name="Circle" size="xSmall" />,
    label: 'Delta',
  },
  {
    icon: <Icon color="burgundy" name="TrendDown" size="small" />,
    label: 'Younger',
  },
  {
    icon: <Icon color="apricot" name="TrendUp" size="small" />,
    label: 'Older',
  },
];

export const DeltaTab = ({userTrends = []}: DeltaTabProps) => {
  const [userTrend] = userTrends || [];
  const {deltaAge, formattedDeltaAge} = userTrend || {};
  const {months, years} = formattedDeltaAge || {};
  const textDeltaAge = deltaAge > 0 ? 'older' : 'younger';
  return (
    <>
      <div className={sprinkles({flex: 'flex', dir: 'col'})}>
        <Text as="h3" color="burgundy" fontWeight="semiBold">
          TallyAge™ Delta
        </Text>
        <Text as="p" color="doveGray">
          {`${years}y ${months}m ${textDeltaAge} than your chronological age.`}
        </Text>
      </div>
      <div
        className={sprinkles({display: 'grid', cols: [4, 8, 10], gap: 24, pT: [40, 64]})}
        style={{rowGap: 64}}>
        <div
          className={sprinkles({
            colSpan: [4, 8, 10],
            colStart: [1, 2, 1],
            dir: 'col',
            flex: 'flex',
            gap: 40,
          })}
          style={{minWidth: 244}}>
          <DeltaTrendChart data={userTrends} />
          <Text
            as="dl"
            className={sprinkles({
              flex: 'flex',
              gap: [16, 24],
              wrap: 'wrap',
              content: 'start',
              items: 'center',
            })}
            color="mineShaft"
            variant="caption">
            {legendItems.map(({icon, label}) => (
              <span className={sprinkles({flex: 'flex', gap: 4, items: 'center'})} key={label}>
                <dt className={sprinkles({flex: 'flex', items: 'center'})}>{icon}</dt>
                <dd className={sprinkles({flex: 'flex', items: 'center'})}>{label}</dd>
              </span>
            ))}
          </Text>
        </div>
      </div>
    </>
  );
};
